/*************************************************/
/* Slider                                        */
/*************************************************/
import Swiper, { Navigation, Autoplay, EffectFade, Pagination } from "swiper";
Swiper.use([Navigation, Autoplay, EffectFade, Pagination]);
import customEventsNames from './../customEventsNames';
export function slider() {
    const latestArticlesSliderSelector = ".latest-articles__cards.swiper";
    const quotesSliderSelector = ".quotes__slider.swiper";
    const certificationsSliderSelector = ".certifications__wrap.swiper";
    const bannerSliderSelector = ".banner__slider.swiper";

    const handleSlideChangeTransitionEnd = function (swiper) {
        //Fix the tabindex for accebility
        swiper.el
            .querySelectorAll(" .swiper-slide > a")
            .forEach((slide) => {
                slide.setAttribute("tabindex", "-1");
            });

        const activeSlide = swiper.el.querySelector(" .swiper-slide-active > a"
        );
        if (activeSlide != null) {
            activeSlide.setAttribute("tabindex", "0");
        }
    };

    const handleSlideChange = function () {
        //Makes sure that the lazyloaded image on the duplicate slide has the right class so it doesnt show up as grey
        var nextDuplicateSlide = document.querySelector(".swiper-slide-duplicate.swiper-slide-next");
        if (nextDuplicateSlide != null) {
            var unloadedSlideImage = nextDuplicateSlide.querySelector("img.lazyloading");
            if (unloadedSlideImage != null) {
                unloadedSlideImage.classList.replace("lazyloading", "lazyloaded");
            }
        }
    }

    const init = function () {

        //Articles sliders
        const articlesSlider = [];
        const articlesSliderElements = document.querySelectorAll(latestArticlesSliderSelector);
        if (articlesSliderElements) {
            articlesSliderElements.forEach(slider => {

                articlesSlider.push(new Swiper(slider, {
                    speed: 500,
                    loop: false,
                    slidesPerView: 1,
                    breakpoints: {
                        // when window width is >= 480px
                        480: {
                            slidesPerView: 2,
                        },
                        // when window width is >= 960px
                        960: {
                            slidesPerView: 3,
                        }
                    },
                    spaceBetween: 40,
                    navigation: {
                        nextEl: '#' + slider.dataset.componentId + " .slider-navigation__next",
                        prevEl: '#' + slider.dataset.componentId + " .slider-navigation__prev",
                    },
                    on: {
                        slideChange: () => {
                            handleSlideChange();
                        },
                        slideChangeTransitionEnd: (swiper) => {
                            handleSlideChangeTransitionEnd(swiper);

                        }
                    }
                }));
            })
        }

        //Quotes sliders
        const quoutesSliders = [];
        const quoutesSlidersElements = document.querySelectorAll(quotesSliderSelector);
        if (quoutesSlidersElements) {
            quoutesSlidersElements.forEach(slider => {

                quoutesSliders.push(new Swiper(slider, {
                    speed: 800,
                    loop: true,
                    autoplay: {
                        delay: 8000,
                        disableOnInteraction: false,
                    },
                    effect: "fade",
                    slidesPerView: 1,
                    pagination: {
                        el: ".slider-pagination",
                        clickable: true,
                    },
                    spaceBetween: 40,
                    on: {
                        slideChange: () => {
                            handleSlideChange();
                        },
                        slideChangeTransitionEnd: (swiper) => {
                            handleSlideChangeTransitionEnd(swiper);

                        }
                    }
                }));
            })
        }

        //Certifications sliders
        const certificationsSlider = [];
        const certificationsSliderElements = document.querySelectorAll(certificationsSliderSelector);
        if (certificationsSliderElements) {
            certificationsSliderElements.forEach(slider => {

                certificationsSlider.push(new Swiper(slider, {
                    speed: 800,
                    autoplay: {
                        delay: 3000,
                        disableOnInteraction: false,
                    },
                    slidesPerView: 2,
                    breakpoints: {
                        // when window width is >= 480px
                        480: {
                            slidesPerView: 2,
                        },
                        // when window width is >= 960px
                        960: {
                            slidesPerView: 3,
                            spaceBetween: 0,
                        }
                    },

                    slidesPerGroup: 2,
                    pagination: {
                        el: ".slider-pagination",
                        clickable: true,
                    },
                    spaceBetween: 20,
                    on: {
                        slideChange: () => {
                            handleSlideChange();
                        },
                        slideChangeTransitionEnd: (swiper) => {
                            handleSlideChangeTransitionEnd(swiper);

                        }
                    }
                }));
            })
        }

        //Banner slider
        const bannerSlider = [];
        const bannerSliderElements = document.querySelectorAll(bannerSliderSelector);
        if (bannerSliderElements) {
            bannerSliderElements.forEach(slider => {
                bannerSlider.push(new Swiper(slider, {
                    speed: 800,
                    autoplay: {
                        delay: 3000,
                        disableOnInteraction: false,
                    },
                    slidesPerView: 1,
                    pagination: {
                        el: ".slider-pagination",
                        clickable: true,
                    },
                    on: {
                        slideChange: () => {
                            handleSlideChange();
                        },
                        slideChangeTransitionEnd: (swiper) => {
                            handleSlideChangeTransitionEnd(swiper);

                        }
                    }
                }));
            })
        }
    };

    init();
}
